export default __webpack_public_path__ + "static/link-01b-dont-d705f198785289883896f771b14527fe.png";